import React from 'react'
import { SORT_DIRECTION_DESC } from '@disco/constants/SortTypes'
import SortIcon from './sort-icon'
import styles from './index.module.css'

export type Props = {
  className?: string
  caption: string
  chosen?: boolean
  sortDirection?: string | null | undefined
  onClick: (...args: Array<any>) => any
}

const ContactSortColumn = (props: Props): React.ReactElement<'a'> => {
  const { className, caption, chosen, sortDirection, onClick } = props
  const icon = chosen ? (
    <SortIcon
      className={styles.contactSortColumnIcon}
      reverseDirection={sortDirection === SORT_DIRECTION_DESC}
    />
  ) : null
  return (
    <a className={className} onClick={onClick}>
      {/*icon*/} {caption}
    </a>
  )
}

export default ContactSortColumn
